import React, { useState, useEffect } from 'react';
import { TextField, Button, Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Checkbox, TablePagination, Autocomplete } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function UsuariosSucursalPerfil() {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const { tienePermiso } = useAccesos();
    const [usuarios, setUsuarios] = useState([]);
    const [perfiles, setPerfiles] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
    const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);
    const [perfilesAsignados, setPerfilesAsignados] = useState({});
    const [perfilesOriginales, setPerfilesOriginales] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { user } = useUser();

    useEffect(() => {
        fetchUsuarios();
        fetchPerfiles();
        fetchSucursales();
    }, []);

    const fetchUsuarios = async () => {
        try {
            const response = await fetch(`${server}/MgUsuarios`);
            const data = await response.json();
            setUsuarios(data.$values);
        } catch (error) {
            console.error('Error al cargar los usuarios:', error);
        }
    };

    const fetchPerfiles = async () => {
        try {
            const response = await fetch(`${server}/sg_perfile`);
            const data = await response.json();
            setPerfiles(data.$values);
        } catch (error) {
            console.error('Error al cargar los perfiles:', error);
        }
    };

    const fetchSucursales = async () => {
        try {
            const response = await fetch(`${server}/MgSucursales`);
            const data = await response.json();
            setSucursales(data.$values);
            console.log(data.$values);
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    };

    const fetchPerfilesAsignados = async () => {
        if (usuarioSeleccionado && sucursalSeleccionada) {
            try {
                const response = await fetch(`${server}/sg_sucursal_usuario_perfil/PerfilesByUsuarioSucursal/${usuarioSeleccionado.codigoUsuario}/${sucursalSeleccionada.idSucursal}`);
                console.log(response);
                const data = await response.json();
                const perfilesAsignados = data.$values.reduce((acc, perfil) => ({ ...acc, [perfil.id]: true }), {});
                setPerfilesAsignados(perfilesAsignados);
                setPerfilesOriginales(perfilesAsignados); // Guardar los perfiles originales
            } catch (error) {
                console.error('Error al cargar los perfiles asignados:', error);
            }
        } else {
            alert('Debe seleccionar un usuario y una sucursal antes de cargar los perfiles.');
        }
    };

    const handleUsuarioChange = (e, newValue) => {
        setUsuarioSeleccionado(newValue);
    };

    const handleSucursalChange = (e, newValue) => {
        setSucursalSeleccionada(newValue);
    };

    const handlePerfilChange = (perfilId) => {
        setPerfilesAsignados(prev => ({
            ...prev,
            [perfilId]: !prev[perfilId]
        }));
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const fechaFormateada = obtenerFechaISOsinZ();

        const operaciones = [];

        for (const [perfilId, isSelected] of Object.entries(perfilesAsignados)) {
            const wasOriginallyAssigned = !!perfilesOriginales[perfilId];

            if (isSelected && !wasOriginallyAssigned) {
                const asignacionToSave = {
                    ingresadoPor: user ? user.codigoUsuario : 'ADMIN               ',
                    id_perfil: perfilId,
                    cod_usuario: usuarioSeleccionado.codigoUsuario,
                    id_sucursal: sucursalSeleccionada.idSucursal
                };
                console.log(asignacionToSave);
                operaciones.push(
                    fetch(`${server}/sg_sucursal_usuario_perfil`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(asignacionToSave),
                    }).catch(error => {
                        console.error(`Error al guardar la asignación de perfil ${perfilId}:`, error);
                    })
                );
            } else if (!isSelected && wasOriginallyAssigned) {

                operaciones.push(
                    fetch(`${server}/sg_sucursal_usuario_perfil/${usuarioSeleccionado.codigoUsuario}/${sucursalSeleccionada.idSucursal}/${perfilId}`, {
                        method: 'DELETE',
                    }).catch(error => {
                        console.error(`Error al eliminar la asignación de perfil ${perfilId}:`, error);
                    })
                );
            }
        }

        try {
            await Promise.all(operaciones);
            alert('Asignaciones actualizadas con éxito');
        } catch {
            alert('Error al actualizar algunas asignaciones');
        }
    };

    const obtenerFechaISOsinZ = () => {
        const fecha = new Date();
        const fechaISO = fecha.toISOString().slice(0, 19);
        return fechaISO;
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredPerfiles = perfiles.filter(perfil =>
        perfil.nombreperfil.toLowerCase().includes(searchQuery)
    );

    return (
        <>
            <div className="right_col" role="main">
                <div className="x_content">
                    <h2>Gestión de Perfiles por Usuario y Sucursal</h2>
                    <br />
                    {/* <div className="row"> */}
                    {/* <div className="col-md-8 col-sm-8 offset-md-2"> */}
                    <form id="UsuariosSucursalPerfil" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                        <div className="item form-group">
                            <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="usuario">Usuario:</label>
                            <div className="col-md-3 col-sm-6">
                                <Autocomplete
                                    options={usuarios}
                                    getOptionLabel={(option) => option.codigoUsuario || ''}
                                    value={usuarioSeleccionado}
                                    onChange={handleUsuarioChange}
                                    isOptionEqualToValue={(option, value) => option.codigoUsuario === value.codigoUsuario}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Seleccione un usuario" variant="outlined" fullWidth />
                                    )}
                                    disabled={!tienePermiso('Seleccionar Usuario Perfil')}
                                />
                            </div>
                        </div>
                        <div className="item form-group">
                            <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="sucursal">Sucursal:</label>
                            <div className="col-md-3 col-sm-6">
                                <Autocomplete
                                    options={sucursales}
                                    getOptionLabel={(option) => option.nombreSucursal || ''}
                                    value={sucursalSeleccionada}
                                    onChange={handleSucursalChange}
                                    isOptionEqualToValue={(option, value) => option.nombreSucursal === value.nombreSucursal}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Seleccione una sucursal" variant="outlined" fullWidth />
                                    )}
                                    disabled={!tienePermiso('Seleccionar Usuario Perfil')}
                                />
                            </div>
                            <div className="col-md-3 col-sm-6">
                                <Button variant="contained" color="primary" onClick={fetchPerfilesAsignados} disabled={!tienePermiso('Seleccionar Usuario Perfil')}>
                                    Cargar Perfiles
                                </Button>
                            </div>
                        </div>
                        <div className="ln_solid" />

                        <div className="row">
                            <div className="col-md-6 col-sm-4 offset-md-2">
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    id="search"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    placeholder="Buscar perfil"
                                />
                                <h2>Perfiles Existentes</h2>
                                <div className="table-responsive">
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Nombre Perfil</TableCell>
                                                    <TableCell align="center">Seleccionar</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {filteredPerfiles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(perfil => (
                                                    <TableRow key={perfil.id}>
                                                        <TableCell>{perfil.nombreperfil}</TableCell>
                                                        <TableCell align="center">
                                                            <Checkbox
                                                                checked={!!perfilesAsignados[perfil.id]}
                                                                onChange={() => handlePerfilChange(perfil.id)}
                                                                disabled={!tienePermiso('Modificar Perfil Usuario')}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={filteredPerfiles.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="ln_solid" />
                        <div className="item form-group">
                            <div className="col-md-6 col-sm-6 offset-md-3">
                                <Button type="submit" variant="contained" color="primary" disabled={!tienePermiso('Guardar Usuario Perfil')}>Guardar Cambios</Button>
                                <Button variant="contained" color="secondary" onClick={() => setPerfilesAsignados(perfilesOriginales)}>Cancelar</Button>
                            </div>
                        </div>
                    </form>
                    {/* </div> */}
                    <div className="ln_solid" />
                    {/* </div> */}
                </div>
            </div>
        </>
    );
}

export default UsuariosSucursalPerfil;
